enum Feature {
  WaitAtServicePoint = 'waitAtServicePoint',
  PickupLater = 'pickupLater',
  RentCar = 'rentCar',
}

export default Feature;
